import Swal from 'sweetalert2'
import i18n from '@/i18n'

function createNewTargetOrObjective({ title, text, pathIfConfirm, context }) {
    Swal({
        title,
        text,
        type: 'info',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: i18n.t('notification.yes'),
        cancelButtonText: i18n.t('notification.no'),
    }).then(swalResponse => {
        if (swalResponse.value == true) {
            return context.$router.push({
                path: pathIfConfirm,
            })
        }
    })
}

export { createNewTargetOrObjective }
